<template>
    <div class="row p-2">
        <div>
            <h1>{{ $t("products.newCalculation") }}</h1>
        </div>
        <div class="mt-4">
            <form @submit.prevent="submitCreation">
                <div class="row col-12 col-lg-6">
                    <div class="col-12 box d-flex flex-column">
                        <label for="inputSelect" class="form-label">{{ $t("products.enterInput") }}</label>
                        <select v-model="postData.selectedInput" class="form-control form-select" id="inputSelect"
                            name="inputSelect" size="1" required>
                            <option v-for="product in products" :key="product.id" :value="product.id">
                                {{ product.name }} ( {{ product.shorten_name }}, {{ product.measurement_unit }} )
                            </option>
                        </select>
                    </div>
                    <div class="col-12 box d-flex flex-column mt-3">
                        <label for="outputSelect" class="form-label">{{ $t("products.enterOutput") }}</label>
                        <select v-model="postData.selectedOutput" class="form-control form-select" id="outputSelect"
                            name="outputSelect" size="1" required>
                            <option v-for="product in products" :key="product.id" :value="product.id"
                                :disabled="product.id === postData.selectedInput">
                                {{ product.name }} ( {{ product.shorten_name }}, {{ product.measurement_unit }} )
                            </option>
                        </select>
                    </div>
                    <div class="col-12 box d-flex flex-column mt-3">
                        <label for="coeficientInput" class="form-label">{{ $t("products.enterCoeficient") }}</label>
                        <input v-model="postData.coeficient" type="text" inputmode="decimal" autocomplete="off"
                            name="coeficient" class="form-control" id="coeficientInput" required />
                        <div v-if="input && output && coeficient > 0" class="form-text">
                            {{ $t("products.conversionRule", {
                                source: input.shorten_name,
                                sourceUnit: input.measurement_unit,
                                output: output.shorten_name,
                                outputUnit: output.measurement_unit,
                                coef: formatAmount(coeficient)
                            }) }}
                        </div>
                    </div>
                    <div class="col-12 mt-4">
                        <button type="submit" class="btn btn-primary text-white px-5 fw-bold">
                            {{ $t("utils.add") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            products: [],
            postData: {
                selectedInput: null,
                selectedOutput: null,
                coeficient: "1"
            },
        }
    },
    created() {
        this.loadData();
    },
    computed: {
        input() {
            return this.products.find((product) => product.id === this.postData.selectedInput);
        },
        output() {
            return this.products.find((product) => product.id === this.postData.selectedOutput);
        },
        coeficient() {
            return this.parseAmount(this.postData.coeficient);
        }
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/unhidden_products").then((response) => {
                this.products = response.data.items
            })
        },
        submitCreation() {
            this.$store.getters.api.post("/product_conversions/add", { ...this.postData, coeficient: this.coeficient }
            ).then((response) => {
                this.$router.push({ name: 'ProductConversions' });
            }).catch((error) => {
                if (error.response.data.error === "Conversion option for this output product already exists") {
                    alert(this.$t("products.covnersionExist"));
                } else {
                    alert(this.$t("warehouses.entryError"));
                }
            });
        },
    }
}
</script>
